import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { errMsg } from "../lib/api";
import { BrandMark } from "../components/BrandMark";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

const HERO = "https://images.pexels.com/photos/10432218/pexels-photo-10432218.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try { await login(form.username, form.password); navigate("/"); }
    catch (err) { setError(errMsg(err)); }
    finally { setBusy(false); }
  };

  return (
    <div className="grid min-h-screen lg:grid-cols-[1fr_1.1fr]">
      <div className="flex flex-col justify-between bg-white px-8 py-10 sm:px-16">
        <BrandMark testId="login-logo" />
        <form onSubmit={submit} className="w-full max-w-sm animate-rise space-y-6" data-testid="login-form">
          <div>
            <div className="eyebrow mb-2">Staff portal</div>
            <h1 className="font-display text-5xl font-bold uppercase leading-none tracking-tight">Sign in</h1>
            <p className="mt-3 text-sm text-zinc-500">Quotes, customers and fabrication designs in one place.</p>
          </div>
          <div className="space-y-2"><Label>Username</Label><Input data-testid="login-username-input" autoFocus value={form.username} onChange={(e) => setForm({ ...form, username: e.target.value })} required className="h-11" /></div>
          <div className="space-y-2"><Label>Password</Label><Input data-testid="login-password-input" type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required className="h-11" /></div>
          {error && <p data-testid="login-error" className="rounded-md bg-red-50 px-3 py-2 text-sm text-red-700">{error}</p>}
          <Button data-testid="login-submit-button" disabled={busy} type="submit" className="h-11 w-full bg-red-600 text-base hover:bg-red-700 active:scale-[0.98]">
            <Lock className="mr-2 h-4 w-4" />{busy ? "Signing in…" : "Sign in"}
          </Button>
          <p className="text-xs text-zinc-400">Accounts are created by your administrator.</p>
        </form>
        <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-400">Plumbing · Commercial Kitchens</div>
      </div>
      <div className="relative hidden lg:block">
        <img src={HERO} alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-zinc-950/60" />
        <div className="absolute bottom-0 left-0 right-0 border-t-4 border-red-600 p-12 text-white">
          <div className="font-display text-4xl font-bold uppercase leading-tight">Measured twice.<br />Quoted once.</div>
        </div>
      </div>
    </div>
  );
}
